import { Card, Col, List, Row, Skeleton, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router";
import { TenantBankDetails } from "../../../../../../types/tenants";
import { RequestBankDetailButton } from "../../../../../organism";
import { EditOutlined } from "@ant-design/icons";
import { Popup } from "../../../../../atoms/Popup";
import EditBankDetail from "./EditBankDetail";
import { useDispatch } from "react-redux";
import { getConfigData } from "../../../../BookingForm/ducks/actions";
import { formatString } from "../../../../../../utils/formatString";

export const BankDetails = (props) => {
  const { id: tenantId } = useParams();
   
  const { tenantData, isLoadingTenantDetails } = useSelector((state: any) => state.tenantsSummary);
  const bankDetails = tenantData?.userDocumentDetail?.bankDetails as TenantBankDetails;
  const [visible, setVisible] = useState(false);
  const [bankList, setBankList] = useState([]);
  const configData = useSelector((state: any) => state.dashboard.configData);
  const { Title } = Typography;
  const dispatch: any = useDispatch();
  useEffect(() => {
    if (!configData?.bankList) {
      dispatch(getConfigData(["bankList"]));
    }
  }, []);

  useEffect(() => {
    if (configData && configData?.bankList && Object.keys(configData?.bankList)?.length > 0) {
      const bankList = configData?.bankList || {};
      const formattedBankList = Object?.entries(bankList as Record<string, string>).map(([key, label]) => ({
        label,
        value: label.toLowerCase().replace(/\s+/g, "_"),
      }));

      setBankList(formattedBankList);
    }
  }, [configData?.bankList]);

  const popup = [
    {
      title: (
        <Title level={3} className="m-0">
          {`Edit Bank Detail`}
        </Title>
      ),
      content: (
        <>
          <EditBankDetail
            bankList={bankList}
            onSubmit={props.onSubmit}
            bankDetails={bankDetails}
            onClose={() => setVisible(false)}
          />
        </>
      ),
      width: 850,
    },
  ];

  const popupProps = {
    closable: true,
    visibility: visible,
    title: popup[0].title,
    content: popup[0].content,
    width: popup[0].width,
    onCancel: () => setVisible(false),
  };
  return (
    <>
      <Row align="middle" gutter={16} style={{ marginBottom: "0.5rem" }}>
        <Col flex="auto">
          <Typography.Title level={5} className="m-0" style={{ lineHeight: "2rem" }}>
            Bank Details
          </Typography.Title>
        </Col>

        <Col flex="none">
          {
            <EditOutlined
              style={{ cursor: "pointer", color: "#3B3B3B", paddingRight: "5px" }}
              onClick={() => setVisible(true)}
            />
          }

          <RequestBankDetailButton
            tenantId={tenantId}
            hasBankDetails={bankDetails && Object.keys(bankDetails).length > 0}
            isLoadingBankDetails={isLoadingTenantDetails}
          />
        </Col>
      </Row>

      <Card bordered={false} className="ag-nospace-body panel-card">
        <List
          dataSource={[
            { title: "Bank Name", description: formatString(bankDetails?.bankName) || "N/A" },
            { title: "Account Name", description: bankDetails?.accountHolderName || "N/A" },
            { title: "Account no.", description: bankDetails?.accountNo || "N/A" },
            { title: "IBAN", description: bankDetails?.iban || "N/A" },
          ]}
          bordered
          renderItem={({ title, description }) => {
            return (
              <List.Item key={title}>
                <Skeleton
                  loading={isLoadingTenantDetails}
                  title={{ style: { marginTop: 0 } }}
                  paragraph={{ rows: 1, style: { marginBlockStart: 16 } }}
                >
                  <List.Item.Meta title={title} description={description} />
                </Skeleton>
              </List.Item>
            );
          }}
        />
        <Popup {...popupProps} />
      </Card>
    </>
  );
};
